import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * Slot-driven React template for the catch-all ContentPage whose backend
 * {@code metadata.templateUid} is {@code "ContentPage1Template"} (legacy
 * {@code layout/contentLayout1Page.jsp}).
 *
 * Structure-copy parity of {@code contentLayout1Page.jsp}: a
 * {@code jsp__user-generated-content} wrapper (typography hook, {@code st4Content.less})
 * containing {@code Section1}, a bootstrap two-column row
 * ({@code Section2A} {@code col-md-3} / {@code Section2B} {@code col-md-9}), and
 * {@code Section3}. The bootstrap {@code container__full}/{@code row}/{@code col-md-*}
 * classes are loaded by the storefront shell, so they are reproduced verbatim.
 *
 * Catch-all content pages (e.g. {@code /material-market-designation}) have no React
 * island, so {@code body} is null.
 */
export function ContentPage1PageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <div className="jsp__user-generated-content">
      {slots.renderSlot("Section1")}
      <div className="container__full">
        <div className="row">
          <div className="col-md-3">{slots.renderSlot("Section2A")}</div>
          <div className="col-md-9">{slots.renderSlot("Section2B")}</div>
        </div>
      </div>
      {slots.renderSlot("Section3")}
      {body}
    </div>
  );
}
